import logoSrc from '../../images/icons/logo.svg';

export const Brand = {
  logoLink: logoSrc,
  name: 'CountMyCents',
};
